import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import flatpickr from "flatpickr";
import breakpoint from 'alpinejs-breakpoints'

window.flatpickr = flatpickr;

Alpine.plugin(breakpoint);

Livewire.start()
